export default __webpack_public_path__ + "static/media/photoshoot.5030a0c3.jpg";